import { TextInput } from "djinn-components";
import { Controller } from "react-hook-form";
import { useSiteState } from "../../../../utils/useSiteState";
import FormHolder from "../../../../components/Form/FormHolder";
import Form from "../../../../components/Form";
import FormFieldErrors from "../../../../components/Form/FormFieldErrors";

const SiteSettingsAdvancedPage = () => {
  const { site, reload } = useSiteState();

  const getDefaults = () => {
    const { ga_property_id } = site;

    return {
      ga_property_id,
    };
  };

  const onSubmit = async (responseData: any) => {
    // await fetchUser();
    await reload();
  };

  return (
    <>
      <title>Advanced settings</title>
      <FormHolder>
        <Form
          getDefaults={getDefaults}
          onCompleted={onSubmit}
          buttonTitle="Save Settings"
          endpoint={`sites/${site.id}`}
          method="patch"
          className="w-2/3"
          render={({ errors, control, isDirty }) => (
            <>
              <h4 className="font-medium text-xl text-white mb-6">
                Advanced Settings
              </h4>

              <div className="mb-4 mt-6">
                <label className="mb-2 block ml-4 text-sm font-medium">
                  Google Analytics
                </label>
                <Controller
                  name="ga_property_id"
                  control={control}
                  rules={{
                    required: false,
                  }}
                  render={({
                    field: { onChange, value },
                  }: any): JSX.Element => (
                    <TextInput
                      value={value}
                      onChange={onChange}
                      invalid={!!errors.ga_property_id}
                      placeholder="Enter GA property ID"
                    />
                  )}
                />

                <FormFieldErrors
                  errors={errors}
                  field="ga_property_id"
                  requiredMessage="Site subdomain is required"
                />
              </div>
            </>
          )}
        />
      </FormHolder>
    </>
  );
};

export default SiteSettingsAdvancedPage;
